import { useIsFetching, useIsMutating } from '@tanstack/react-query';

import { ESHOP_QUERY_KEY } from '../model';

export const useIsProductPageMutating = () => {
    const isMutating = useIsMutating();
    const isFetching = useIsFetching({ queryKey: [ESHOP_QUERY_KEY.CART] });

    return Boolean(isMutating + isFetching);
};
